exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nagm-map {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.card {\n    -webkit-box-shadow: 0 10px 10px rgba(0, 0, 0, .3);\n            box-shadow: 0 10px 10px rgba(0, 0, 0, .3);\n    opacity: 0.7;\n}\n\n.searchBox  {\n    float: right;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Michel/Documents/edenz_local/cellwatchWebApp/src/app/dashboard/dashboard.component.css
// module id = ../../../../../src/app/dashboard/dashboard.component.css
// module chunks = main